
import React from "react";
import { useDashboardStats } from "@/hooks/use-dashboard-stats";
import { DashboardStatsCards } from "./dashboard/dashboard-stats-cards";
import { ApiStatsChart } from "./dashboard/api-stats-chart";
import { ActiveSessionsTable } from "./dashboard/active-sessions-table";
import { TokenUsageChart } from "./dashboard/token-usage-chart";
import { LoggingStatus } from "./dashboard/logging-status";

const AdminDashboard = () => {
  const { stats, apiStats, activeSessions, recentTokenUsage, loading, error } = useDashboardStats();

  if (error) {
    return (
      <div className="container mx-auto p-6">
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <h3 className="text-red-800 font-medium">Feil ved lasting av dashboard</h3>
          <p className="text-red-600 text-sm mt-1">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-6 space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Admin Dashboard</h1>
      </div>

      <DashboardStatsCards stats={stats} loading={loading} />

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <ActiveSessionsTable sessions={activeSessions} loading={loading} />
        <LoggingStatus />
      </div>

      <TokenUsageChart tokenUsage={recentTokenUsage} loading={loading} />

      <ApiStatsChart apiStats={apiStats} loading={loading} />
    </div>
  );
};

export default AdminDashboard;
